import {
  PriorityContainerCommon,
  PriorityNumberCommon,
} from 'src/components/atoms/Priority/Priority.styles';
import styled from 'styled-components';

export const DividerContainer = styled.div`
  padding: 0 20px;
`;

export const CategoryListItem = styled.li<{ row: number }>`
  display: flex;
  align-items: start;
  column-gap: 20px;
  margin: 0;
  padding: 0;
  margin-bottom: 20px;
`;

export const CategoryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  margin: 0;
  column-gap: 20px;
  height: 100%;
`;

export const OrderContainer = styled(PriorityContainerCommon)``;

export const OrderNumber = styled(PriorityNumberCommon)``;

export const CategoryJoiner = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
`;
